<template>
  <!--
    The view for the layoutTextList-component.
    used to display the themes layotTextElements.
  -->
  <div class="layoutTextOverview">
    <LayoutTextList
      ref="layoutTextList"
      :theme-id="themeId"
      @reloadAuditLogs="reloadAuditLogs"
    />
    <DatabaseAuditLogList
      ref="databaseAuditLogList"
      :theme-id="themeId"
      :is-theme-elements="true"
      @reload="reloadLayoutElementList"
    />
  </div>
</template>

<script>
export default {
  name: "LayoutTextOverview",
  components: {
    LayoutTextList: () => import('@/components/VideoPostprocessing/Theme/LayoutTextList.vue'),
    DatabaseAuditLogList: () => import('@/components/DatabaseAuditLogs/DatabaseAuditLogsList.vue')
  },
  props: {
    themeId: {
      type: String,
      required: true
    }
  },
  metaInfo () {
    return {
      title: this.$t('videoPostProcessing.title')
    }
  },
  methods: {
    reloadAuditLogs () {
      this.$refs.databaseAuditLogList.reloadAuditLogs();
    },
    reloadLayoutElementList () {
      this.$refs.layoutTextList.closeAndReloadData();
    },
  }
}
</script>
